import React, { useRef, useEffect } from 'react';
import { Group, Panel } from 'react-resizable-panels';
import { useTheme } from "@mui/material";
import ResizeSeparator from 'components/ResizeSeparator';


const GanttLayout = ({
    topDefaultSize = 80,
    bottomCollapsible = false,
    topLeft,
    topRight,
    bottomLeft,
    bottomRight,
}) => {
    const theme = useTheme();
    const topLeftRef = useRef(null);

    /* -----------------------------
    * Sync width TOP LEFT → BOTTOM
    * ----------------------------- */
    useEffect(() => {
        if (!topLeftRef.current) return;

        const observer = new ResizeObserver(([entry]) => {
            const width = entry.contentRect.width;
            document.documentElement.style.setProperty(
                '--gantt-left-width',
                `${width}px`
            );
        });

        observer.observe(topLeftRef.current);
        return () => observer.disconnect();
    }, []);


    return (
        <Group orientation="vertical" style={{ height: '100%' }}>
            {/* ================= TOP ================= */}
            <Panel 
                defaultSize={topDefaultSize} 
                minSize={0}
            >
                <Group direction="horizontal" style={{ height: '100%' }}>
                    {/* TOP LEFT */}
                    <Panel defaultSize={topLeft.defaultSize} minSize={topLeft.minSize}>
                        <div
                            ref={topLeftRef}
                            style={{ height: '100%', overflow: 'hidden' }}
                        >
                            {topLeft.content}
                        </div>
                    </Panel>

                    <ResizeSeparator gripVisible={false} />

                    {/* TOP RIGHT */}
                    <Panel defaultSize={topRight.defaultSize} minSize={topRight.minSize}>
                        <div style={{ height: '100%', overflow: 'hidden' }}>
                            {topRight.content}
                        </div>
                    </Panel>
                </Group>
            </Panel>

            {!bottomCollapsible && (
                <>
                    {/* =========== HORIZONTAL SPLITTER ========== */}
                    {!bottomCollapsible && (<ResizeSeparator orientation="horizontal" gripVisible={false} />)}

                    {/* ================= BOTTOM ================= */}
                    <Panel 
                        defaultSize={100 - topDefaultSize}
                        minSize={0}
                        collapsible={bottomCollapsible}
                    >
                        <div
                            style={{
                                display: 'flex',
                                height: '100%',
                                width: '100%',
                            }}
                        >
                            {/* BOTTOM LEFT (SYNC WIDTH) */}
                            <div
                                style={{
                                    width: 'var(--gantt-left-width)',
                                    minWidth: bottomLeft.minSize ?? 0,
                                    overflow: 'hidden',
                                }}
                            >
                                {bottomLeft.content}
                            </div>

                            <div
                                style={{
                                    position: 'relative',
                                    zIndex: 10,
                                    width: 8,
                                    height: '100%',
                                    background: 'transparent',
                                }}
                            >
                                <div
                                    style={{
                                        pointerEvents: 'none',
                                        position: 'absolute',
                                        left: '50%',
                                        top: 0,
                                        width: 1,
                                        height: '100%',
                                        backgroundColor: theme.palette.neutral.main || "#fff",
                                        transform: 'translateX(-50%)',
                                    }}
                                />
                            </div>
                            
                            {/* BOTTOM RIGHT */}
                            <div
                                style={{
                                    flex: 1,
                                    overflow: 'hidden',
                                }}
                            >
                                {bottomRight.content}
                            </div>
                        </div>
                    </Panel>
                </>
            )}
        </Group>
    );
};

export default React.memo(GanttLayout);
